/* global angular */

angular
  .module('specsguardApp')
  .filter('sgDate', sgDate);

// @ts-ignore
function sgDate () {
  return function (value) {
    if (angular.isUndefined(value) || value === null) {
      return '-';
    }
    const dt = new Date(value);
    const today = new Date();
    return today.toDateString() === dt.toDateString() ?
      `${dt.getHours()}:${('0' + dt.getMinutes()).slice(-2)}` :
      `${dt.getDate()}-${dt.getMonth()}-${dt.getFullYear()}`;
  };
}

